import { API_BASE } from './api-base';

/**
 * POST a non-empty question to /api/questions. Backend ignores empty/whitespace
 * payloads as defence-in-depth, but the client also filters here.
 *
 * Failures are silent — the reading flow must not block on the question log.
 */
export async function logQuestion(userName: string, question: string): Promise<void> {
  if (!question.trim()) return;
  try {
    await fetch(`${API_BASE}/api/questions`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ user_name: userName || 'guest', question }),
    });
  } catch {
    // Non-critical — backend may be down in static mode.
  }
}
